<template>
  <v-container fluid class="valeurs-container">
    <v-layout row wrap :class="$vuetify.breakpoint.xsOnly ? 'py-2' : 'px40 py-4'">
      <v-flex xs12 sm12 md6 :class="$vuetify.breakpoint.xsOnly ? 'px-4 py-3' : 'px40 py-4'">
        <h3>{{ $t('Home.Valeurs.Titre1') }}</h3>
        <balance-border :color="'secondary'" />
        <p class="txt-justify mb-3">{{ $t('Home.Valeurs.pl1') }}</p>
        <p class="txt-justify">{{ $t('Home.Valeurs.pl2') }}</p>
      </v-flex>
      <v-flex xs12 sm12 md6 :class="$vuetify.breakpoint.xsOnly ? 'px-4 py-3' : 'px40 py-4'">
        <h3>{{ $t('Home.Valeurs.Titre2') }}</h3>
        <balance-border :color="'primary'" />
        <p class="txt-justify mb-3">{{ $t('Home.Valeurs.pr1') }}</p>
        <p class="txt-justify">{{ $t('Home.Valeurs.pr2') }}</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BalanceBorder from '@/components/BalanceBorder.vue'

export default {
  name: 'valeurs-section',
  components: {
    BalanceBorder
  }
}
</script>

<style scoped>
.xsOnly .valeurs-container h3 {
  font-size: 13px;
}
.xsOnly .valeurs-container p {
  font-size: 12px;
}
</style>

